import { render } from "./ParagraphImageLeftRight.vue?vue&type=template&id=374a7be0"
import script from "./ParagraphImageLeftRight.vue?vue&type=script&lang=js"
export * from "./ParagraphImageLeftRight.vue?vue&type=script&lang=js"

import "./ParagraphImageLeftRight.vue?vue&type=style&index=0&id=374a7be0&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__